export class CumulationHistoryModel {
    public amount!: number;
    public createDate!: string;
    public id!: number;
    public uId!: number;
    public orderId!: number;
    public orderType!: number;
}

